"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("../../../../../../../../components/Button"));
var react_i18next_1 = require("react-i18next");
var Icon_1 = __importDefault(require("../../../../../../../../components/Icon"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var FormActions = function (_a) {
    var addNewMortgage = _a.addNewMortgage, removeMortgage = _a.removeMortgage, isLast = _a.isLast, index = _a.index, isFirst = _a.isFirst;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.form_actions_container }, isLast ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(Button_1.default, { variant: "text", onClick: addNewMortgage },
                react_1.default.createElement(Icon_1.default, { semanticName: "plus circle" }),
                t('POST_SCREEN.ADD_NEW_MORTGAGE_SECTION'))),
        !isFirst && (react_1.default.createElement("div", null,
            react_1.default.createElement(Button_1.default, { className: styles_module_scss_1.default.delete_btn, variant: "text", onClick: function () { return removeMortgage(index); } },
                react_1.default.createElement(Icon_1.default, { semanticName: "trash alternate outline" })))))) : (react_1.default.createElement("div", null,
        react_1.default.createElement(Button_1.default, { className: styles_module_scss_1.default.delete_btn, variant: "text", onClick: function () { return removeMortgage(index); } },
            react_1.default.createElement(Icon_1.default, { semanticName: "trash alternate outline" }))))));
};
exports.default = FormActions;
